import { FormGridField } from "../../components/FormGrid";
import * as Yup from "yup";

export interface BetJackpotArrayDefinition {
    name: string;
    id: string;
    placeholder?: string;
    label?: string;
    disabled?: boolean;
    decimal?: boolean;
    items?: any;
    fieldOverrides?: any;
    schemaName: string;
    buildFormGridField: (schema) => FormGridField;
}

export default function buildBetJackpotArrayDefinition({
    name,
    id,
    placeholder,
    label,
    disabled,
    decimal,
    items,
    fieldOverrides,
    schemaName
}: {
    name: string;
    id: string;
    placeholder?: string;
    label?: string;
    disabled?: boolean;
    decimal?: boolean;
    items?: any;
    fieldOverrides?: any;
    schemaName: string;
}): BetJackpotArrayDefinition {
    return {
        name,
        id,
        placeholder,
        label,
        disabled,
        decimal,
        items,
        fieldOverrides,
        schemaName,
        buildFormGridField: _createBetJackpotArrayField
    };
}

function _createBetJackpotArrayField(schema): FormGridField {
    const {
        name,
        id,
        placeholder,
        label,
        disabled,
        decimal,
        items,
        fieldOverrides,
        schemaName
    } = this;
    let fieldsValidations ={}
    items.map((coin)=>fieldsValidations[coin.value]=Yup.number()
        .required(`Field for ${coin.label} is required. `)
        .min(0, `Field for ${coin.label} must be ≥ than 0`)
        .max(100, `Field for ${coin.label} must be ≤ than 100`)
    )
    return {
        name,
        fieldType: "betJackpotArray",
        fieldOptions: {
            id,
            items,
            label,
            disabled
        },
        validation: Yup.array(Yup.object(fieldsValidations)).required("Field is required."),
        columnClass: "col-12",
        formSpacing: true,
        ...fieldOverrides
    };
}
